import styled from 'styled-components';
import { AvatarMixin } from '../../mixins/components/AvatarMixin';
export var StyledAvatar = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledAvatar",
  componentId: "c11n-8-111-1__sc-1581h9e-0"
})(["", ""], AvatarMixin);